import React from 'react';
import PropTypes from 'prop-types';

const ShowInfoIcon = ({
  color,
  size,
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 16 12"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.787109 6C1.41378 2.58667 4.40511 0 7.99978 0C11.5944 0 14.5851 2.58667 15.2124 6C14.5858 9.41333 11.5944 12 7.99978 12C4.40511 12 1.41444 9.41333 0.787109 6V6ZM7.99978 9.33333C8.88383 9.33333 9.73168 8.98214 10.3568 8.35702C10.9819 7.7319 11.3331 6.88406 11.3331 6C11.3331 5.11595 10.9819 4.2681 10.3568 3.64298C9.73168 3.01786 8.88383 2.66667 7.99978 2.66667C7.11572 2.66667 6.26788 3.01786 5.64275 3.64298C5.01763 4.2681 4.66644 5.11595 4.66644 6C4.66644 6.88406 5.01763 7.7319 5.64275 8.35702C6.26788 8.98214 7.11572 9.33333 7.99978 9.33333ZM7.99978 8C7.46934 8 6.96064 7.78929 6.58556 7.41421C6.21049 7.03914 5.99978 6.53043 5.99978 6C5.99978 5.46957 6.21049 4.96086 6.58556 4.58579C6.96064 4.21071 7.46934 4 7.99978 4C8.53021 4 9.03892 4.21071 9.41399 4.58579C9.78906 4.96086 9.99978 5.46957 9.99978 6C9.99978 6.53043 9.78906 7.03914 9.41399 7.41421C9.03892 7.78929 8.53021 8 7.99978 8Z"
      fill={color}
    />
  </svg>
);

ShowInfoIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

ShowInfoIcon.defaultProps = {
  color: '#656B7C',
  size: 16,
};

export default ShowInfoIcon;
